import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "overflow-hidden rounded-lg border border-gray-200 mb-7"
};
const _hoisted_2 = { class: "min-w-full divide-y divide-gray-200 text-sm" };
const _hoisted_3 = { class: "divide-y divide-gray-100" };
const _hoisted_4 = {
    colspan: "2",
    class: "px-4 py-2"
};
const _hoisted_5 = { class: "text-lg font-semibold text-gray-900" };
const _hoisted_6 = { class: "mt-1 flex flex-wrap gap-0.5" };
const _hoisted_7 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ($setup.articlesStore.details)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("table", _hoisted_2, [
                _createElementVNode("tbody", _hoisted_3, [
                    _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_4, [
                            _createElementVNode("h2", _hoisted_5, _toDisplayString($setup.articlesStore.details.articleGroupName), 1 /* TEXT */)
                        ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.articlesStore.details?.properties, ({ items, itemsFilter, text, title }) => {
                        return (_openBlock(), _createElementBlock("tr", { key: title }, [
                            _createElementVNode("td", {
                                class: _normalizeClass(["w-1/3 px-4 py-2 font-medium text-gray-600 bg-gray-50 align-top", { 'whitespace-pre-line': String(title).includes('\n') }])
                            }, _toDisplayString(title), 3 /* TEXT, CLASS */),
                            (items?.length)
                                ? (_openBlock(), _createElementBlock("td", {
                                    key: 0,
                                    class: _normalizeClass(["px-4 py-2 text-gray-800", { 'whitespace-pre-line': String(items.join(' ')).includes('\n') }])
                                }, [
                                    _createTextVNode(_toDisplayString(text) + " ", 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_6, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                                            return (_openBlock(), _createElementBlock("div", { key: item }, [
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["inline-block px-[9px] py-[5px] font-medium bg-mertl-grey text-white rounded-md hover:bg-mertl-dark-blue text-sm transition-colors", { 'cursor-pointer': !!itemsFilter }]),
                                                    onClick: _withModifiers(async () => {
                                                        if (item && itemsFilter) {
                                                            await $setup.router.push({
                                                                query: {
                                                                    ...$setup.route.query,
                                                                    ...{
                                                                        [itemsFilter]: item.value,
                                                                        startIndex: 1,
                                                                        material: undefined,
                                                                        shape: undefined,
                                                                    },
                                                                },
                                                            });
                                                        }
                                                    }, ["prevent"])
                                                }, _toDisplayString(item.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_7)
                                            ]));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ])
                                ], 2 /* CLASS */))
                                : (_openBlock(), _createElementBlock("td", {
                                    key: 1,
                                    class: _normalizeClass(["px-4 py-2 text-gray-800", { 'whitespace-pre-line': String(text).includes('\n') }])
                                }, _toDisplayString(text), 3 /* TEXT, CLASS */))
                        ]));
                    }), 128 /* KEYED_FRAGMENT */))
                ])
            ])
        ]))
        : _createCommentVNode("v-if", true);
}
